import React, { createContext, useContext, useState, useEffect, FC, ReactNode } from 'react';
import { CushionType, ShapeFilterContextType } from 'types/shapeFilter.types';

const ShapeFilterContext = createContext<ShapeFilterContextType | undefined>(undefined);

export const ShapeFilterProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedCushionType, setSelectedCushionType] = useState<CushionType>(null);

  // Retrieve the value of localStorage when initializing the context
  useEffect(() => {
    const storedCushionType = localStorage.getItem('selectedCushionType') as CushionType | null;
    if (storedCushionType) {
      setSelectedCushionType(storedCushionType);
    }
  }, []);

  // Save value to localStorage every time selectedCushionType is updated
  useEffect(() => {
    if (selectedCushionType) {
      localStorage.setItem('selectedCushionType', selectedCushionType);
    } else {
      localStorage.removeItem('selectedCushionType');
    }
  }, [selectedCushionType]);

  return (
    <ShapeFilterContext.Provider value={{ selectedCushionType, setSelectedCushionType }}>
      {children}
    </ShapeFilterContext.Provider>
  );
};

export const useShapeFilter = () => {
  const context = useContext(ShapeFilterContext);
  if (!context) {
    throw new Error('useShapeFilter must be used within a ShapeFilterProvider');
  }
  return context;
};
